<template>
  <div class="activity-library-homepage">
    <ActionsHeader v-if="viewMode == false" @activitySearch="activitySearch" @filterChanged="onFilterChanged" @onOrganizeByChange="onOrganizeByChange" :allFilterTypes="allFilterTypes" :_views="views" :isViewEmpty="isViewEmpty" :viewMode="viewMode" @updateColumns="updateColumns()" :migrationData="migrationData">
      <div class="create_activity" v-if="viewMode == false">
        <button :class="getLibraryAccess()" class="btn align-items-center" type="button" v-on:click="createActivity()">
          <img class="list_icon" src="static/img/activity-configurator/Create-Activity.svg" />
          <span class="text">Create Activity</span>
        </button>
      </div>
    </ActionsHeader>
    <div class="activity-library-table__container">
      <div class="container">
        <div class="header-core" v-if="migrationData.activityMigration && userProfileData.userRole == 'SystemAdmin'">
          <ul class="nav-bar nav-test d-xs-none nav-margin-md nav" id="pills-tab" role="tablist">
            <li class="nav-item indicator" role="presentation" @click="switchTabs('coreLibrary')">
              <a :class="{ active: coreLibrary }" class="nav-link">Core Library</a>
            </li>
            <li class="nav-item indicator" role="presentation" @click="switchTabs('threadLibrary')">
              <a :class="{ active: threadLibrary }" class="nav-link">THREAD Library</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="coreLibrary">
      <DCFActionsHeader @activitySearch="activitySearch" @filterChanged="onFilterChanged" @onOrganizeByChange="onOrganizeByChange" :allFilterTypes="allFilterTypes" :_views="views" :isViewEmpty="isViewEmpty" :viewMode="viewMode" @updateColumns="updateColumns()" v-if="viewMode == true">
        <div class="create_activity" v-if="viewMode == false">
          <button :class="getLibraryAccess()" class="btn align-items-center" type="button" v-on:click="createActivity()">
            <img class="list_icon" src="static/img/activity-configurator/Create-Activity.svg" />
            <span class="text">Create Activity</span>
          </button>
        </div>
      </DCFActionsHeader>
      <div class="row mt-20">
        <div :class="showPreview == true ? 'table-container col-lg-5 p-0' : 'table-container col-lg-12 p-0'" v-if="!isDisplayGroupwise && views">
          <div v-if="viewMode === false">
            <DraftsTable
              tableType="Drafts"
              :data="drafts"
              :count="draftsCount"
              :currentView="currentView"
              :views="views"
              v-if="draftsCount > 0"
              @previewActivity="previewActivity($event)"
              @onSortColumn="onSortColumn($event, 'draft')"
              @deleteActivity="deleteActivity($event)"
              :viewMode="viewMode"
              :previewSelectedId="previewSelectedId"
              :pagination="draftsPagination"
              @onPageChange="onDraftsPageChange"
            />

            <!-- ACTIVE ACTIVITIES CHANGES -->
            <DraftsTable
              tableType="Active"
              :data="activeActivities"
              :count="activeActivitiesCount"
              :currentView="currentView"
              :views="views"
              v-if="activeActivitiesCount > 0"
              @previewActivity="previewActivity($event)"
              @onSortColumn="onSortColumn($event, 'active')"
              @deleteActivity="deleteActivity($event)"
              :viewMode="viewMode"
              :previewSelectedId="previewSelectedId"
              :pagination="activeActivitiesPagination"
              @onPageChange="onActivePageChange"
              @changeStatustoArchive="changeStatustoArchive"
              @onPinActivity="onPinActivity($event, 'Active')"
              @onUnpinActivity="onUnpinActivity($event, 'Active')"
              @refreshActivityList="refreshActivityList"
              :migrationData="migrationData"
            />
          </div>
          <ActivitiesTable
            :data="activities['ACTIVITIES'].rows || []"
            :count="activities['ACTIVITIES'].count"
            title="ACTIVITIES"
            :views="views"
            :currentView="currentView"
            @changeView="changeView"
            style="margin-bottom: 25px"
            v-if="activities"
            @previewActivity="previewActivity($event)"
            @onPinActivity="onPinActivity($event, 'Activities', 'ACTIVITIES')"
            @onUnpinActivity="onUnpinActivity($event, 'Activities', 'ACTIVITIES')"
            @onSortColumn="onSortColumn($event, 'ACTIVITIES')"
            @onPageChange="onPageChange"
            :pagination="paginationDetails['ACTIVITIES']"
            @changeStatustoArchive="changeStatustoArchive"
            @refreshActivityList="refreshActivityList"
            :viewMode="viewMode"
            :studyId="studyId"
            :previewSelectedId="previewSelectedId"
            :migrationData="migrationData"
          />
        </div>

        <div v-else-if="views && activities" :class="showPreview == true ? 'table-container col-lg-5 p-0' : 'table-container col-lg-12 p-0'">
          <ActivitiesTable
            v-for="(activitiesOfGroup, groupName) in activities"
            :key="groupName"
            :data="activitiesOfGroup.rows || []"
            :count="activitiesOfGroup.count"
            :views="views"
            :title="groupName"
            :currentView="currentView"
            @changeView="changeView"
            @previewActivity="previewActivity($event)"
            @onPinActivity="onPinActivity($event, 'Activities', groupName)"
            @onUnpinActivity="onUnpinActivity($event, 'Activities', groupName)"
            @onSortColumn="onSortColumn($event, groupName)"
            @onPageChange="onPageChange"
            :pagination="paginationDetails[groupName]"
            @changeStatustoArchive="changeStatustoArchive"
            @refreshActivityList="refreshActivityList"
            :viewMode="viewMode"
            :studyId="studyId"
            :previewSelectedId="previewSelectedId"
          />
        </div>

        <div class="preview-activity col-lg-6 ml-60 mt-30 pt-15 container-stylee float-right bg-white" v-if="views && showPreview == true">
          <div class="row mb-15">
            <div class="col-lg-3 device-view-btn" v-if="showDeviceButton == true && showStepView == true" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/surveyPreview/phone.png" />Device view</div>
            <div class="col-lg-3" v-if="showDeviceButton == false && showStepView == true"></div>
            <div class="col-lg-3 device-view-btn" v-if="showStepView == false" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/activity-configurator/device-step-preview.svg" />Step view</div>
            <div class="col-lg-5 activity-data-name-preview" v-if="showStepView == true">
              {{ activityData.name }}
            </div>
            <div class="col-lg-4 p-0" v-if="showStepView == true">
              <div class="row float-right">
                <div class="col-lg-6 pb-10">{{ activityData.stepsCount }}&nbsp;Screens</div>
                <div v-if="activityData.timeToComplete" class="col-lg-6 pb-10">{{ activityData.timeToComplete }}&nbsp;min</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" v-if="showStepView == true">
              <readOnlyQuestions class :questions="questionAnswers" :activityData="activityData" :hideEditBtn="true" @editedEvent="questionIsEdited"></readOnlyQuestions>
            </div>
            <div v-if="showStepView == false" class="col-md-12 device-view-preview">
              <deviceQuestionsViewLibrary
                class
                :questions="questionAnswers"
                :activityData="activityData"
                :intrupted="intrupted"
                @resetIntrupt="intrupted = false"
                @isProcessing="
                  val => {
                    isExporting = val;
                  }
                "
                @editedEvent="questionIsEdited"
              ></deviceQuestionsViewLibrary>
              <div v-if="isExporting" class="loader" @click="intrupted = true">
                <div class="loader-container">
                  <p><b>Processing</b></p>
                  <i class="fa fa-spinner fa-spin"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-20" v-if="threadLibrary">
      <div :class="showPreview == true ? 'table-container col-lg-5 p-0' : 'table-container col-lg-12 p-0'" v-if="!isDisplayGroupwise && views">
        <ThreadLibraryComponenet
          :data="activities['ACTIVITIES'].rows || []"
          :count="activities['ACTIVITIES'].count"
          title="ACTIVITIES"
          :views="views"
          :currentView="currentView"
          @changeView="changeView"
          style="margin-bottom: 25px"
          v-if="activities"
          @previewActivity="previewActivity($event)"
          @onPinActivity="onPinActivity($event, 'Activities', 'ACTIVITIES')"
          @onUnpinActivity="onUnpinActivity($event, 'Activities', 'ACTIVITIES')"
          @onSortColumn="onSortColumn($event, 'ACTIVITIES')"
          @onPageChange="onPageChange"
          :pagination="paginationDetails['ACTIVITIES']"
          @changeStatustoArchive="changeStatustoArchive"
          @refreshActivityList="refreshActivityList"
          :viewMode="viewMode"
          :studyId="studyId"
          :previewSelectedId="previewSelectedId"
          :migrationData="migrationData"
        />
      </div>
      <div v-else-if="views && activities" :class="showPreview == true ? 'table-container col-lg-5 p-0' : 'table-container col-lg-12 p-0'">
        <ThreadLibraryComponenet
          v-for="(activitiesOfGroup, groupName) in activities"
          :key="groupName"
          :data="activitiesOfGroup.rows || []"
          :count="activitiesOfGroup.count"
          :views="views"
          :title="groupName"
          :currentView="currentView"
          @changeView="changeView"
          @previewActivity="previewActivity($event)"
          @onPinActivity="onPinActivity($event, 'Activities', groupName)"
          @onUnpinActivity="onUnpinActivity($event, 'Activities', groupName)"
          @onSortColumn="onSortColumn($event, groupName)"
          @onPageChange="onPageChange"
          :pagination="paginationDetails[groupName]"
          @changeStatustoArchive="changeStatustoArchive"
          @refreshActivityList="refreshActivityList"
          :viewMode="viewMode"
          :studyId="studyId"
          :previewSelectedId="previewSelectedId"
          :migrationData="migrationData"
        />
      </div>
      <div class="preview-activity col-lg-6 ml-60 mt-30 pt-15 container-stylee float-right bg-white" v-if="views && showPreview == true">
        <div class="row mb-15">
          <div class="col-lg-3 device-view-btn" v-if="showDeviceButton == true && showStepView == true" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/surveyPreview/phone.png" />Device view</div>
          <div class="col-lg-3" v-if="showDeviceButton == false && showStepView == true"></div>
          <div class="col-lg-3 device-view-btn" v-if="showStepView == false" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/activity-configurator/device-step-preview.svg" />Step view</div>
          <div class="col-lg-5 activity-data-name-preview" v-if="showStepView == true">
            {{ activityData.name }}
          </div>
          <div class="col-lg-4 p-0" v-if="showStepView == true">
            <div class="row float-right">
              <div class="col-lg-6 pb-10">{{ activityData.stepsCount }}&nbsp;Screens</div>
              <div v-if="activityData.timeToComplete" class="col-lg-6 pb-10">{{ activityData.timeToComplete }}&nbsp;min</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="showStepView == true">
            <readOnlyQuestions class :questions="questionAnswers" :activityData="activityData" :hideEditBtn="true" @editedEvent="questionIsEdited"></readOnlyQuestions>
          </div>
          <div v-if="showStepView == false" class="col-md-12 device-view-preview">
            <deviceQuestionsViewLibrary
              class
              :questions="questionAnswers"
              :activityData="activityData"
              :intrupted="intrupted"
              @resetIntrupt="intrupted = false"
              @isProcessing="
                val => {
                  isExporting = val;
                }
              "
              @editedEvent="questionIsEdited"
            ></deviceQuestionsViewLibrary>
            <div v-if="isExporting" class="loader" @click="intrupted = true">
              <div class="loader-container">
                <p><b>Processing</b></p>
                <i class="fa fa-spinner fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import toastr from "toastr";
import ActionsHeader from "@/components/activity-library/activity-library-actions-header";
import DCFActionsHeader from "@/components/activity-library/activity-library-dcf-actions-header";
import DraftsTable from "@/components/activity-library/drafts-table";
import ActivitiesTable from "@/components/activity-library/activities-table";
import * as columnNames from "@/constants/activity-library-and-configurator-component/column-names";
import readOnlyQuestions from "@/components/activity-library/activity-preview-read-only-questions";
import deviceQuestionsViewLibrary from "@/components/activity-library/activity-device-view-library";
import ThreadLibraryComponenet from "@/components/activity-library/thread-library";
import _ from "lodash";
import { mapGetters } from "vuex";
import { STUDY_ADMIN } from "@/constants/authRoles";
import { AclRule } from "vue-acl";

const defaultView1 = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA, columnNames.CREATED_BY, columnNames.GROUP, columnNames.STEPS, columnNames.DURATION, columnNames.LANGUAGE, columnNames.LAST_MODIFIED];
const defaultView2 = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA, columnNames.TAGS, columnNames.VERSION, columnNames.INSTANCES, columnNames.STUDIES, columnNames.STEPS, columnNames.DURATION, columnNames.LANGUAGE];

export default {
  data() {
    return {
      clientFeaturs: null,
      isExporting: false,
      intrupted: false,
      viewMode: false,
      studyId: null,
      activityId: null,
      userProfileData: { activityLibraryAllowed: false },
      showPreview: false,
      showStepView: true,
      showDeviceButton: true,
      activityData: { title: "", nickName: "", questions: [] },
      questionAnswers: [],
      activityTypes: {},
      edcActivityTypeIds: [],
      therapeuticAreas: {},
      activities: null,
      drafts: [],
      activeActivities: [],
      draftsCount: 0,
      activeActivitiesCount: 0,
      initialActivityQueryParams: {
        pageNum: 0,
        pageSize: 20,
        sortOrder: "DESC",
        sortValue: "modified_time",
        targetLibrary: null
      },
      draftQueryParams: {
        pageNum: 0,
        pageSize: 20,
        sortOrder: "DESC",
        sortValue: "modified_time"
      },
      activeActivitiesQueryParams: {
        pageNum: 0,
        pageSize: 20,
        sortOrder: "DESC",
        sortValue: "modified_time"
      },
      expanded: false,
      isDisplayGroupwise: false,
      VIEW_1: 1,
      VIEW_2: 2,
      currentView: 1,
      filterObj: {},
      views: null,
      originalViews: null,
      defaultView1,
      defaultView2,
      allFilterTypes: {
        AREA: "therapeuticAreaId",
        TYPE: "typeId",
        CREATEDBY: "createdBy",
        LANGUAGES: "language",
        TAGS: "tags"
      },
      isViewEmpty: true,
      isQuestionInEditMode: false,
      previewSelectedId: null,
      pagination: {
        current: 1,
        total: 1
      },
      organizeByTitles: [],
      queryParams: {},
      paginationDetails: {},
      DEFAULT_ACTIVITY_PAGE_SIZE: 20,
      DEFAULT_ORGAINZE_BY_PAGE_SIZE: 10,
      DEFAULT_DRAFTS_PAGE_SIZE: 5,
      DEFAULT_ACTIVE_ACTIVITIES_PAGE_SIZE: 5,
      organizeByQueryParam: null,
      draftsPagination: {
        current: 0,
        total: 1
      },
      activeActivitiesPagination: {
        current: 0,
        total: 1
      },
      coreLibrary: true,
      threadLibrary: false,
      migrationData: {
        threadLibrary: false,
        activityMigration: false
      },
      targetLibrary: "Thread"
    };
  },
  components: {
    ActionsHeader,
    DCFActionsHeader,
    DraftsTable,
    ActivitiesTable,
    readOnlyQuestions,
    deviceQuestionsViewLibrary,
    ThreadLibraryComponenet
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    }
  },
  mounted() {
    this.getClientFeatures();
    this.getUserProfileDetails();
    this.activityId = this.$route.params.activityId;
    if (this.$route.params.viewMode) {
      this.viewMode = this.$route.params.viewMode;
    }
    if (this.$route.params.studyId) {
      this.studyId = this.$route.params.studyId;
      this.viewMode = true;
    }
  },
  watch: {
    isDisplayGroupwise(val) {
      if (!val) {
        this.organizeByActivities = null;
        this.organizeByTitles = [];
      }
    }
  },

  methods: {
    getClientFeatures() {
      this.$api
        .getClientAllFeatures()
        .then(response => {
          window.localStorage.removeItem("clientFeatures");
          window.localStorage.setItem("clientFeatures", JSON.stringify(response.body));
          response.data.forEach(data => {
            if (data.featureKey == "ACTIVITY_MIGRATION" && data.enabled) {
              this.migrationData.activityMigration = true;
            }
          });
        })
        .catch(() => {
          this.$toastr.error("Error in getting client feature list");
        });
    },
    switchTabs(tab) {
      if (this.threadLibrary == true && tab == "coreLibrary") {
        this.showPreview = false;
      }
      if (this.coreLibrary == true && tab == "threadLibrary") {
        this.showPreview = false;
      }
      if (tab == "coreLibrary") {
        this.coreLibrary = true;
        this.threadLibrary = false;
        this.initialActivityQueryParams.targetLibrary = null;
        this.getDraftsList();
        this.getActiveActivitiesList();
        this.getActivitiesList();
        this.migrationData.threadLibrary = false;
      } else {
        this.initialActivityQueryParams.targetLibrary = "Thread";
        this.getDraftsList();
        this.getActiveActivitiesList();
        this.getActivitiesList();
        this.coreLibrary = false;
        this.threadLibrary = true;
        this.migrationData.threadLibrary = true;
      }
    },
    updateColumns() {
      this.getActivityViews();
    },
    changeView(view) {
      this.currentView = view;
    },
    getActivityType(typeId) {
      if (this.activityTypes[typeId]) {
        return this.activityTypes[typeId];
      }
      return null;
    },
    getUserProfileDetails() {
      this.$api.getProfileDetails(this.user.id, this.studyId).then(response => {
        this.userProfileData = response.data;
      });
    },
    getLibraryAccess() {
      if (this.user.userRole == "StudyAdmin") {
        if (this.userProfileData.activityLibraryAllowed == false) {
          return "library_disabled_property";
        }
      }
    },
    toggleStepView() {
      const activitytype = this.getActivityType(this.activityData.typeId);
      this.showStepView = !this.showStepView;
      this.showDeviceButton = true;
      if (activitytype && activitytype.is_participant_facing == 1) {
        this.showStepView = true;
        this.showDeviceButton = false;
      }
    },
    questionIsEdited() {},
    createActivity() {
      this.$router.push({
        name: "activity-details",
        params: { activityId: 0 }
      });
    },
    onOrganizeByChange(organizeByValue) {
      // Organize by value will be empty for 'All Activities'
      this.activities = null;
      this.queryParams = null;
      this.pagination.current = 1;
      if (organizeByValue) {
        this.isDisplayGroupwise = true;
        this.organizeByQueryParam = organizeByValue;
        this.initialActivityQueryParams.pageSize = this.DEFAULT_ORGAINZE_BY_PAGE_SIZE;
      } else {
        this.organizeByQueryParam = null;
        this.resetDraftsPagination();
        this.getDraftsList();

        this.resetActiveActivities();
        this.getActiveActivitiesList();

        this.isDisplayGroupwise = false;
        this.initialActivityQueryParams.pageSize = this.DEFAULT_ACTIVITY_PAGE_SIZE;
      }
      this.organizeByTitles = [];
      this.getActivitiesList();
    },
    getTherapeuticAreas() {
      this.$api
        .getTherapeuticAreas()
        .then(response => {
          const therapeuticAreas = response.data.result;
          _.forEach(therapeuticAreas, therapeuticArea => {
            this.therapeuticAreas[therapeuticArea.id] = therapeuticArea;
          });
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          const activityTypes = response.data.result;
          _.forEach(activityTypes, activityType => {
            this.activityTypes[activityType.id] = activityType;

            if (this.$route.name == "data-capture-form-activity-library") {
              if (activityType.type != "PRO (Patient Reported Outcome)") {
                this.edcActivityTypeIds.push(activityType.id);
              }
            } else {
              this.edcActivityTypeIds.push(activityType.id);
            }
          });
          this.getDraftsList();
          this.getActiveActivitiesList();
          this.getActivitiesList();
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    activitySearch(search) {
      this.filterObj.name = search;
      this.setAllTablesToFirstPage();
      this.getActivitiesList();
      if (!this.isDisplayGroupwise) {
        this.resetDraftsPagination();
        this.getDraftsList();

        this.resetActiveActivities();
        this.getActiveActivitiesList();
      }
    },
    // No need to pass tableTitle for the initial get call
    getActivitiesList(tableTitle) {
      if (this.studyId) {
        const typeIds = this.edcActivityTypeIds;
        if (!this.filterObj.typeId) {
          this.filterObj.typeId = typeIds.join(",");
        }
      }
      const filterObj = { ...this.filterObj };
      let queryParams;
      filterObj.status = this.organizeByQueryParam !== null ? "All" : "Published";
      const filterObjStringified = JSON.stringify(filterObj);
      this.initialActivityQueryParams.pageNum = 0;
      if (this.queryParams && this.queryParams[tableTitle]) {
        queryParams = { ...this.queryParams[tableTitle] };
      } else {
        queryParams = { ...this.initialActivityQueryParams };
        this.queryParams = {};
      }
      if (this.organizeByQueryParam !== null) {
        queryParams.groupBy = this.organizeByQueryParam;
        queryParams.pageSize = this.DEFAULT_ORGAINZE_BY_PAGE_SIZE;
      } else {
        queryParams.pageSize = this.DEFAULT_ACTIVITY_PAGE_SIZE;
      }
      this.$api
        .getActivitiesList(filterObjStringified, queryParams)
        .then(response => {
          if (response.data.result) {
            this.activities = null;
            const activities = response.data.result;
            const titles = Object.keys(activities);
            this.activities = {};
            _.forEach(titles, title => {
              // Setting Pagination Data

              if (!this.paginationDetails[title]) {
                this.$set(this.paginationDetails, title, {});
                this.paginationDetails[title].total = 0;
                this.paginationDetails[title].current = 0;
              }

              // Setting Query Params Data
              if (!this.queryParams[title]) {
                this.$set(this.queryParams, title, {
                  ...this.initialActivityQueryParams
                });
              }

              this.$set(this.activities, title, activities[title]);

              if (this.isDisplayGroupwise) {
                this.organizeByTitles.push(title);
              }

              const pageSize = this.isDisplayGroupwise ? this.DEFAULT_ORGAINZE_BY_PAGE_SIZE : this.DEFAULT_ACTIVITY_PAGE_SIZE;
              let totalPages = Math.floor(this.activities[title].count / pageSize) + 1;
              if (this.activities[title].count % pageSize === 0) {
                totalPages -= 1;
              }
              if (this.activities[title].count === 0) {
                totalPages = 1;
              }
              this.paginationDetails[title].total = totalPages;

              _.forEach(this.activities[title].rows, activity => {
                if (activity.typeId && this.activityTypes[activity.typeId]) {
                  activity.type = this.activityTypes[activity.typeId].type;
                }
                if (activity.therapeuticAreaId && this.therapeuticAreas[activity.therapeuticAreaId]) {
                  activity.therapeuticArea = this.therapeuticAreas[activity.therapeuticAreaId].name;
                }
              });
            });
          }
        })
        .catch(() => {
          this.$toastr.error("Error in getting Published activities");
        });
    },
    getDraftsList() {
      if (this.studyId) {
        return;
      }
      const filterObj = { ...this.filterObj };
      filterObj.status = "Draft";
      const filterObjStringified = JSON.stringify(filterObj);
      this.draftQueryParams.pageSize = this.DEFAULT_DRAFTS_PAGE_SIZE;
      this.draftQueryParams.pageNum = this.draftsPagination.current;
      this.$api
        .getActivitiesList(filterObjStringified, this.draftQueryParams)
        .then(response => {
          if (response.data.result) {
            this.draftsCount = response.data.result.ACTIVITIES.count;
            this.drafts = response.data.result.ACTIVITIES.rows;

            const pageSize = this.DEFAULT_DRAFTS_PAGE_SIZE;

            let totalPages = Math.floor(this.draftsCount / pageSize) + 1;
            if (this.draftsCount % pageSize === 0) {
              totalPages -= 1;
            }
            if (this.draftsCount === 0) {
              totalPages = 1;
            }
            this.draftsPagination.total = totalPages;

            _.forEach(this.drafts, activity => {
              if (activity.typeId && this.activityTypes[activity.typeId]) {
                activity.type = this.activityTypes[activity.typeId].type;
              }
              if (activity.therapeuticAreaId && this.therapeuticAreas[activity.therapeuticAreaId]) {
                activity.therapeuticArea = this.therapeuticAreas[activity.therapeuticAreaId].name;
              }
            });
          }
        })
        .catch(() => {
          this.$toastr.error("Error in getting Drafts activities");
        });
    },
    getActiveActivitiesList() {
      if (this.studyId) {
        return;
      }
      const filterObj = { ...this.filterObj };

      // ACTIVE ACTIVITIES CHANGES
      filterObj.status = "Active";
      const filterObjStringified = JSON.stringify(filterObj);
      this.activeActivitiesQueryParams.pageSize = this.DEFAULT_ACTIVE_ACTIVITIES_PAGE_SIZE;
      this.activeActivitiesQueryParams.pageNum = this.activeActivitiesPagination.current;
      this.$api
        .getActivitiesList(filterObjStringified, this.activeActivitiesQueryParams)
        .then(response => {
          if (response.data.result) {
            this.activeActivitiesCount = response.data.result.ACTIVITIES.count;
            this.activeActivities = response.data.result.ACTIVITIES.rows;

            const pageSize = this.DEFAULT_ACTIVE_ACTIVITIES_PAGE_SIZE;

            let totalPages = Math.floor(this.activeActivitiesCount / pageSize) + 1;
            if (this.activeActivitiesCount % pageSize === 0) {
              totalPages -= 1;
            }
            if (this.activeActivitiesCount === 0) {
              totalPages = 1;
            }
            this.activeActivitiesPagination.total = totalPages;

            _.forEach(this.activeActivities, activity => {
              if (activity.typeId && this.activityTypes[activity.typeId]) {
                activity.type = this.activityTypes[activity.typeId].type;
              }
              if (activity.therapeuticAreaId && this.therapeuticAreas[activity.therapeuticAreaId]) {
                activity.therapeuticArea = this.therapeuticAreas[activity.therapeuticAreaId].name;
              }
            });
          }
        })
        .catch(() => {
          this.$toastr.error("Error in getting Active activities");
        });
    },
    setDefaultViews() {
      this.views = {};
      this.views[this.VIEW_1] = this.defaultView1;
      this.views[this.VIEW_2] = this.defaultView2;
      this.originalViews = _.cloneDeep(this.views);
    },
    getActivityViews() {
      this.$api
        .getActivityViews()
        .then(response => {
          const views = response.body.result || [];

          if (views.length) {
            const tempCol1 = [];
            let tempName1 = [];
            const respCols1 = views[0].cols.split(",");
            _.forEach(respCols1, columnName => {
              tempName1 = columnName.split("#");
              if (tempName1[1] == "1") {
                tempCol1.push(tempName1[0]);
              }
            });

            const tempCol2 = [];
            let tempName2 = [];
            const respCols2 = views[1].cols.split(",");
            _.forEach(respCols2, columnName => {
              tempName2 = columnName.split("#");
              if (tempName2[1] == "1") {
                tempCol2.push(tempName2[0]);
              }
            });

            this.views = {};
            this.views[this.VIEW_1] = tempCol1;
            this.views[this.VIEW_2] = tempCol2;
            this.originalViews = _.cloneDeep(this.views);
            this.isViewEmpty = false;
          } else {
            this.setDefaultViews();
          }
        })
        .catch(() => {
          this.$toastr.error("Failed to get activity views. Setting default views for now");
          this.setDefaultViews();
        });
    },
    deleteActivity(activityId) {
      swal({
        title: "Are you sure you want to delete the draft activity?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "No",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api.deleteActivity(activityId).then(
            () => {
              toastr.success("Activity deleted successfully");
              this.getDraftsList();
            },
            error => {
              toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting the ePRO");
            }
          );
        }
      });
    },
    onPinActivity(reqObj, title) {
      this.$api
        .pinActivity(reqObj.activityId, reqObj.revisionId)
        .then(() => {
          let activity = {};
          if (title == "Activities") {
            activity = this.activities[title.toUpperCase()].rows.find(act => act.revisionId === reqObj.revisionId);
          } else if (title == "Active") {
            activity = this.activeActivities.find(act => act.revisionId === reqObj.revisionId);
          }

          activity.pinStatus = 1;
          this.$toastr.success("Activity pinned successfully");
        })
        .catch(() => {
          this.$toastr.error("Could not pin the activity");
        });
    },
    onUnpinActivity(reqObj, title) {
      this.$api
        .unpinActivity(reqObj.activityId, reqObj.revisionId)
        .then(() => {
          let activity = {};
          if (title == "Activities") {
            activity = this.activities[title.toUpperCase()].rows.find(act => act.revisionId === reqObj.revisionId);
          } else if (title == "Active") {
            activity = this.activeActivities.find(act => act.revisionId === reqObj.revisionId);
          }
          activity.pinStatus = 0;
          this.$toastr.success("Activity unpinned successfully");
        })
        .catch(() => {
          this.$toastr.error("Could not unpin the activity");
        });
    },
    previewActivity(previewActivityObj) {
      const activityId = previewActivityObj.activityId;
      this.previewSelectedId = previewActivityObj.previewSelectedId;
      if (previewActivityObj.id === this.previewSelectedId) {
        this.showPreview = !this.showPreview;
      } else {
        this.showPreview = true;
      }
      if (this.previewSelectedId == previewActivityObj.id) {
        this.previewSelectedId = null;
      } else {
        this.previewSelectedId = previewActivityObj.id;
      }

      this.showStepView = true;
      if (this.showPreview == false) {
        this.views = this.originalViews;
      }
      if (this.showPreview == true) {
        this.views = {};
        this.views[this.VIEW_1] = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA];
        this.views[this.VIEW_2] = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA];
        this.questionAnswers = [];
        this.activityData = {};
        this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
        this.getActivityDetails(activityId, previewActivityObj.revisionId);
      }
    },
    getActivityDetails(activityId, revisionId) {
      this.$api.getActivityDetails(activityId, revisionId).then(
        response => {
          this.activityData = response.data.result;
          const activitytype = this.getActivityType(this.activityData.typeId);
          this.showDeviceButton = true;
          if (activitytype && activitytype.is_participant_facing == 1) {
            this.showStepView = true;
            this.showDeviceButton = false;
          }

          this.$store.dispatch("setActivityDetailsAction", response.data.result);
          if (this.activityData.questions && this.activityData.questions.length > 0) {
            this.questionAnswers = this.processQuestion(response.data.result.questions);
            this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
          }
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          toastr.error(this.errorMsg);
        }
      );
    },
    processQuestion(question) {
      question.map(function(value) {
        if (value.type == "SurveyInstruction") {
          if (value.formattedTitle == "") {
            value.formattedTitle = value.title;
          }
          if (value.formattedInformation == "") {
            value.formattedInformation = value.information;
          }
        } else if (value.type == "CustomScale" && value.formattedLabels == undefined) {
          value.formattedLabels = value.labels;
        } else {
          if (value.formattedBody == "") {
            value.formattedBody = value.body;
          }
          if (value.options !== undefined && value.options.formattedBody == "") {
            value.options.formattedBody = value.options.body;
          }
        }
      });
      return question;
    },
    onFilterChanged(filter) {
      this.filterObj = { ...this.filterObj, ...filter };
      this.setAllTablesToFirstPage();
      this.getActivitiesList();

      if (!this.isDisplayGroupwise) {
        this.resetDraftsPagination();
        this.resetActiveActivities();
        this.getDraftsList();
        this.getActiveActivitiesList();
      }
    },

    setAllTablesToFirstPage() {
      if (!this.paginationDetails) {
        return;
      }

      const tableTitles = Object.keys(this.paginationDetails);

      if (!tableTitles.length) {
        return;
      }

      tableTitles.forEach(title => {
        this.paginationDetails[title].current = 0;
      });
    },
    onSortColumn({ column, order }, tableTitle) {
      let sortValue = column.name;
      if (column.name === "therapeuticArea") {
        sortValue = "therapeuticAreaId";
      }
      if (column.name === "type") {
        sortValue = "typeId";
      }

      if (tableTitle === "draft") {
        this.draftQueryParams = {
          ...this.draftQueryParams,
          sortValue,
          sortOrder: order,
          pageNum: 0
        };
        this.resetDraftsPagination();
        this.getDraftsList();
        return;
      }

      if (tableTitle === "active") {
        this.activeActivitiesQueryParams = {
          ...this.activeActivitiesQueryParams,
          sortValue,
          sortOrder: order,
          pageNum: 0
        };
        this.resetActiveActivities();
        this.getActiveActivitiesList();
        return;
      }

      this.paginationDetails[tableTitle].current = 0;
      this.queryParams[tableTitle] = {
        ...this.queryParams[tableTitle],
        sortValue,
        sortOrder: order,
        pageNum: this.paginationDetails[tableTitle].current
      };
      this.getActivitiesListForATable(tableTitle);
    },

    onPageChange({ direction, tableTitle }) {
      if (this.paginationDetails[tableTitle].current === 0 && direction === -1) {
        return;
      }

      if (this.paginationDetails[tableTitle].current + 1 === this.paginationDetails[tableTitle].total && direction === 1) {
        return;
      }

      this.paginationDetails[tableTitle].current += direction;
      this.queryParams[tableTitle].pageNum = this.paginationDetails[tableTitle].current;

      this.getActivitiesListForATable(tableTitle);
    },

    onDraftsPageChange(direction) {
      if (this.draftsPagination.current === 0 && direction === -1) {
        return;
      }

      if (this.draftsPagination.current + 1 === this.draftsPagination.total && direction === 1) {
        return;
      }

      this.draftsPagination.current += direction;
      this.draftQueryParams.pageNum = this.draftsPagination.current;

      this.getDraftsList();
    },

    onActivePageChange(direction) {
      if (this.activeActivitiesPagination.current === 0 && direction === -1) {
        return;
      }

      if (this.activeActivitiesPagination.current + 1 === this.activeActivitiesPagination.total && direction === 1) {
        return;
      }

      this.activeActivitiesPagination.current += direction;
      this.activeActivitiesQueryParams.pageNum = this.activeActivitiesPagination.current;

      this.getActiveActivitiesList();
    },

    resetDraftsPagination() {
      this.draftsPagination.current = 0;
      this.draftsPagination.total = 1;
    },

    resetActiveActivities() {
      this.activeActivitiesPagination.current = 0;
      this.activeActivitiesPagination.total = 1;
    },

    setPaginationData(count, pageSize) {
      const numberOfPages = Math.floor(count / pageSize);
      this.pagination.total = numberOfPages;
    },
    refreshActivityList() {
      this.getActivitiesList();
      this.getActiveActivitiesList();
    },
    changeStatustoArchive(reqObj) {
      this.$api
        .updateActivityStatus(
          reqObj.activityId,
          reqObj.revisionId,
          "Archived",
          {},
          {
            targetLibrary: this.migrationData && this.migrationData.threadLibrary ? reqObj.targetLibrary : ""
          }
        )
        .then(() => {
          toastr.success("Activity archived successfully");
          this.getActivitiesList();
          this.getActiveActivitiesList();
        })
        .catch(error => {
          this.errorMsg = error.body ? error.body.message : "Error while archiving activity";
        });
    },
    getActivitiesListForATable(tableTitle) {
      const filterObj = { ...this.filterObj };
      filterObj.status = tableTitle === "Drafts" ? "Drafts" : "Published";
      this.queryParams[tableTitle].pageNum = this.paginationDetails[tableTitle].current;
      const queryParams = { ...this.queryParams[tableTitle] };
      if (this.organizeByQueryParam !== null) {
        queryParams.groupBy = this.organizeByQueryParam;
        filterObj.status = "All";
        if (this.organizeByQueryParam == "group_name") {
          filterObj.group_id = tableTitle == "NONE" ? "NONE" : this.activities[tableTitle].rows[0].groupId;
        } else if (this.organizeByQueryParam == "created_by") {
          filterObj.created_by = tableTitle;
        } else if (this.organizeByQueryParam == "tags") {
          filterObj.tag_id = tableTitle;
        }
      }

      const filterObjStringified = JSON.stringify(filterObj);
      this.$api
        .getActivitiesList(filterObjStringified, queryParams)
        .then(response => {
          if (response.data.result) {
            const newActivitiesData = response.data.result[tableTitle];
            this.activities[tableTitle] = newActivitiesData;
            _.forEach(this.activities[tableTitle].rows, activity => {
              if (activity.typeId && this.activityTypes[activity.typeId]) {
                activity.type = this.activityTypes[activity.typeId].type;
              }
              if (activity.therapeuticAreaId && this.therapeuticAreas[activity.therapeuticAreaId]) {
                activity.therapeuticArea = this.therapeuticAreas[activity.therapeuticAreaId].name;
              }
            });
          }
        })
        .catch(() => {
          this.$toastr.error("Error in getting Published activities");
        });
    }
  },
  async created() {
    this.getTherapeuticAreas();
    this.getActivityViews();
    this.getActivityTypes();
  }
};
</script>

<style>
.device-view-btn {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c8ce4;
  cursor: pointer;
  z-index: 90;
}
.activity-data-name-preview {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  text-align: center;
}
.loader {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffffa1;
  z-index: 99;
}
.loader .loader-container {
  margin: auto;
  text-align: center;
  vertical-align: middle;
  margin-top: calc(50vh - 30px);
  border: 0px solid;
  width: 118.4px;
  height: 118.4px;
  padding: 15px 15px 15px 15px;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.45);
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.45);
  background-color: #ffffff;
}
.loader .loader-container .fa.fa-spin {
  font-size: 3em;
}
.loader .fa-spinner {
  font-size: 24px;
  color: #4c8ce4;
}
/* .device-view-preview {
  margin: 0 auto;
  position: relative;
  top: -123px;
} */
.header-core {
  margin-top: 2px;
  position: relative;
  top: 27px;
}
.nav {
  background: #fff;
  border-bottom: 1px solid #d4dfe4;
}
.nav-bar .nav-link.active {
  font-weight: 600;
  border-bottom-color: #4c8ce4;
}
.nav-bar .nav-link {
  color: #2d3752 !important;
  padding: 26px 20px 9px;
  border-bottom: 4px solid transparent;
}
.indicator {
  cursor: pointer;
}
.activity-library-table__container .container {
  max-width: 90%;
}
.act-step-box-slider .vue-box-select li {
  display: inline-block;
  margin: 0 8px !important;
}
</style>
